import React from 'react';
import CubeSpinner from './CubeSpinner';

const Spinner = () => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <CubeSpinner />
    </div>
  );
};

export default Spinner;